import http from './http';

export async function listResidences(params) {
  const { data } = await http.get('/residences', { params });
  return data;
}

export async function listMyAssignedResidences() {
  const { data } = await http.get('/residences/me/assigned');
  return data;
}

export async function getResidence(id) {
  const { data } = await http.get(`/residences/${id}`);
  return data;
}

export async function createResidence(payload) {
  const { data } = await http.post('/residences', payload);
  return data;
}

export async function updateResidence(id, payload) {
  const { data } = await http.put(`/residences/${id}`, payload);
  return data;
}

export async function deleteResidence(id) {
  await http.delete(`/residences/${id}`);
}
